export type ClipboardCopySuccessEventDetail = {
  copied_text: string;
};

export const CLIPBOARD_COPY_SUCCESS_EVENT_NAME =
  'ekko:clipboard-copy-success';

export function dispatch_clipboard_copy_success_event(copied_text: string) {
  window.dispatchEvent(
    new CustomEvent<ClipboardCopySuccessEventDetail>(
      CLIPBOARD_COPY_SUCCESS_EVENT_NAME,
      {
        detail: { copied_text },
      },
    ),
  );
}
